import Header from "../UI/Header";
import MarketingMenu from "./Menu";

const MarketingLayout = (props) => {
  const userData = props.userData;
  const menu = props.menu;

  return (
    <div id="marketing-layout">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="container-menu border-end">
            <MarketingMenu userData={userData} active={menu}/>
          </div>
          <div className="container-main">
            <Header userData={userData} />
            <hr className="m-0"/>
            <div className="main p-4">
              {props.children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketingLayout;
